export default {
  common: {
    required: '*Campo obrigatório'
  },
  email: {
    invalid: 'E-mail informado é inválido'
  }
}
